import { ApolloError } from "@apollo/client";

// The codes the marketing delivery API refuses a request with; each has a message.
const KNOWN_ERROR_CODES = new Set([
  "marketing-provider-invalid",
  "marketing-credentials-required",
  "marketing-secret-invalid",
  "marketing-webhook-secret-invalid",
  "marketing-sending-domain-invalid",
  "marketing-from-address-invalid",
  "marketing-from-name-invalid",
  "marketing-reply-to-invalid",
  "marketing-delivery-not-configured",
  "marketing-test-recipient-invalid",
  "marketing-provider-not-allowed",
]);

// The codes a test email comes back with when it was not accepted; each has a message.
const KNOWN_TEST_SEND_ERROR_CODES = new Set([
  "marketing-recipient-not-allowed",
  "marketing-provider-not-allowed",
  "marketing-provider-error",
  "fake-recipient-rejected",
]);

// The message key for a refused request; null for an unexpected error.
export const marketingDeliveryErrorKey = (error: unknown): string | null => {
  const code = error instanceof ApolloError ? error.graphQLErrors[0]?.message : undefined;
  return code && KNOWN_ERROR_CODES.has(code) ? `marketingDelivery.errors.${code}` : null;
};

// The message key for the error code of a test email that was not accepted.
export const marketingTestSendResultKey = (errorCode: string): string =>
  KNOWN_TEST_SEND_ERROR_CODES.has(errorCode)
    ? `marketingDelivery.testSend.errors.${errorCode}`
    : "marketingDelivery.testSend.failed";
